import { Center, Heading } from '@chakra-ui/layout';
import React from 'react';

const NotFound: React.FC = () => {
  return (
    <Center>
      <Heading>Not Found</Heading>
    </Center>
  );
};

export default NotFound;
